import { HttpParams } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { ConductorService } from '@app/core/services/conductor.service';

@Component({
  selector: 'app-conductores-cards',
  standalone: false,
  templateUrl: './conductores-cards.component.html',
  styleUrl: './conductores-cards.component.scss'
})
export class ConductoresCardsComponent implements OnInit {
  private readonly conductorService = inject(ConductorService);

  loading = true;

  totalConductores = 0;
  conductoresActivos = 0;
  licenciaVigente = 0;
  licenciaVencida = 0;
  mdVigente = 0;
  mdVencido = 0;

  ngOnInit(): void {
    this.loadMetrics();
  }

  private loadMetrics(): void {
    this.loading = true;

    const params = new HttpParams()
      .set('page', 1)
      .set('perPage', 100000)
      .set('sortByProperty', 'id_visible')
      .set('sortBy', 'desc');

    this.conductorService.getAll(params).subscribe({
      next: (data) => {
        const conductores = data.entities ?? [];
        const hoy = Date.now();

        this.totalConductores = data.count || conductores.length;

        this.conductoresActivos = conductores.filter(
          (c) => c.activo === 'Activo' || Number(c.activo) === 1
        ).length;

        this.licenciaVigente = conductores.filter((c) => {
          if (!c.vencimiento_licencia) return false;
          const ts = new Date(c.vencimiento_licencia).getTime();
          return !Number.isNaN(ts) && ts >= hoy;
        }).length;

        this.licenciaVencida = conductores.filter((c) => {
          if (!c.vencimiento_licencia) return false;
          const ts = new Date(c.vencimiento_licencia).getTime();
          return !Number.isNaN(ts) && ts < hoy;
        }).length;

        this.mdVigente = conductores.filter((c) =>
          (c.estado_defensivo ?? '').toLowerCase().includes('vig')
        ).length;

        this.mdVencido = conductores.filter((c) =>
          (c.estado_defensivo ?? '').toLowerCase().includes('venc')
        ).length;

        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  get porcentajeActivos(): number {
    return this.totalConductores > 0
      ? Math.round((this.conductoresActivos / this.totalConductores) * 100)
      : 0;
  }
}
